/**
 * Task Store Constants
 *
 * Centralized constants for task-related mysid values and other task store constants.
 */

export const TASK_MYSID = {
  /** mysid for organizational/table tasks */
  TABLE_TASKS: 'table_tasks',
  /** mysid for personal tasks (side panel, toolbar, etc.) */
  PERSONAL_TASKS: 'personal_tasks',
  /** mysid for data-room upload placeholder flow only; separate session so unsubscribe does not clear side panel */
  PERSONAL_TASKS_UPLOAD_PLACEHOLDER: 'personal_tasks_upload_placeholder',
  /** mysid for deal tasks */
  DEAL_TASKS: 'deal_tasks',
  /** mysid for workflow tasks */
  WORKFLOW_TASKS: 'workflow_tasks',
} as const;

export type TaskMysid = (typeof TASK_MYSID)[keyof typeof TASK_MYSID];
